// extracted by mini-css-extract-plugin
module.exports = {"text-message-bubble":"_1fEr9t4c","textMessageBubble":"_1fEr9t4c"};